var _defs, _path, _g, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentButtons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3616",
    "data-name": "Rectangle 3616",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7821",
    "data-name": "Rectangle 7821",
    width: 33.253,
    height: 38.713,
    transform: "translate(0 0)",
    fill: "#5048bf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7820",
    "data-name": "Rectangle 7820",
    width: 27.472,
    height: 11.65,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32339",
    "data-name": "Group 32339",
    transform: "translate(-451 -2159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9386",
    "data-name": "Group 9386",
    transform: "translate(451 2159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9385",
    "data-name": "Group 9385",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32342",
    "data-name": "Group 32342",
    transform: "translate(12.574 10.644)",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34493",
    "data-name": "Path 34493",
    d: "M10.053,35.054V30.807H32.745v4.247a2.1,2.1,0,0,1-2.1,2.1H12.154a2.1,2.1,0,0,1-2.1-2.1",
    transform: "translate(0.508 1.557)",
    fill: "#002c77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32341",
    "data-name": "Group 32341",
    transform: "translate(0 0)",
    opacity: 0.99,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32340",
    "data-name": "Group 32340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32339-2",
    "data-name": "Group 32339",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34494",
    "data-name": "Path 34494",
    d: "M27.472,5.82a5.811,5.811,0,0,1-5.82,5.831h-2.08V8.373a5.847,5.847,0,0,0-5.841-5.831A5.838,5.838,0,0,0,7.9,8.373v3.278H5.82A5.825,5.825,0,0,1,5.82,0H21.652a5.82,5.82,0,0,1,5.82,5.82",
    transform: "translate(0 0)",
    fill: "#4972f4"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34495",
    "data-name": "Path 34495",
    d: "M32.742,21.813V30H10.05V8.713a3.134,3.134,0,0,1,.935-2.238,3.172,3.172,0,0,1,5.421,2.248v9.045l2.658.357,11.85,1.586a2.109,2.109,0,0,1,1.828,2.1",
    transform: "translate(0.508 0.28)",
    fill: "#5048bf"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7822",
    "data-name": "Rectangle 7822",
    width: 31.653,
    height: 36.85,
    transform: "translate(14.173 11.575)",
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentButtons);
export default __webpack_public_path__ + "static/media/payment_buttons.3c1f62afb4d1e0edec4669673d3eafc5.svg";
export { ForwardRef as ReactComponent };